<template>
  <div class="componentBox">
    <h2 class="componentTitle">客户信息</h2>
    <Cell :colList="list" :detail="detail" />
  </div>
</template>

<script>
import Cell from './Cell.vue';
export default {
  components: {Cell},
  props: ['detail'],
  data() {
    return {
      list: [
        {title: '客户姓名',field: 'customerName',},
        {title: '电话',field: 'customerPhone',},
        {title: '省市区/县',field: 'area',},
        {title: '详细地址',field: 'address',},
        {title: '池塘面积(亩)',field: 'pondArea',},
        {title: '池塘水深(米)',field: 'pondWaterDepth',},
        {title: '水源情况',field: 'waterCondition',},
        {title: '增氧机/水车配置(台)',field: 'aeratorWaterWheelNum',},
        {title: '增氧机/水车配置(kw/台)',field: 'aeratorWaterWheelPower',},
        {title: '投饵机(台)',field: 'baitThrower',},
        {title: '备注',field: 'remark',},
        {title: '业务员',field: 'salesManName',},
        {title: '所属工厂',field: 'factoryName',},
        {title: '聚落/片区',field: 'settlementName',},
      ],
    }
  },
  watch: {
    detail(){
      
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>